import React, { FC, useState, useCallback, useContext } from 'react';
import {getInitialViewSettings, UserViewSettings, ViewIdentifiable} from "../../../models/common/ViewSettings";
import {DataFilterComponentBaseProps, DataFilterInput} from "./DataFilterInput";
import {OptionType, SelectOptionTypes} from "../../form/SearchableSelect";
import {isOptionTypeArray} from "../../../helpers/Validators";
import { ActionMeta } from 'react-select';
import AsyncSelect from "../../form/AsyncSelect";
import {
    constructDataFilter,
    createFilterDisplayTitle,
    DataFilter,
    DataFilterTypes
} from "../../../models/common/DataFilter";
import { useSelector, useDispatch } from 'react-redux';
import {AppState} from "../../../reducers/RootReducer";
import {fetchInitialSelectOptions, fetchSelectOptions} from "../../../actions/common/SelectActions";
import {ApiRouteableProp} from "../../../models/common/ApiReturnType";
import {LanguageContext} from "../../../config/ContextConfig";


export interface AsyncIdFilterInputProps extends DataFilterComponentBaseProps, ViewIdentifiable, ApiRouteableProp {
    onSelectChange?: ( option: OptionType ) => void
}

export function AsyncIdFilterInput (
    {
        route,
        filterName,
        isInvertedActive,
        noDivider,
        onAddFilterClick,
        title,
        viewIdentifier,
        onSelectChange
    }: AsyncIdFilterInputProps
) {

    const [ selectedOption, setSelectedOption ] = useState<OptionType>({ label: "", value: "0" });
    const [ inverted, setInverted ] = useState( isInvertedActive ?? false );

    const language = useContext( LanguageContext );

    const dispatch = useDispatch();
    const onInputChangeHandler = useCallback(
        ( selectIdentifier: string, routeX: string, userViewSettings: UserViewSettings ) =>
            dispatch( fetchSelectOptions( selectIdentifier, routeX, userViewSettings ) ),
        [dispatch]
    );
    const selectState = useSelector( ( state: AppState ) => state.SelectComponentsReducer.selects );

    const selectChangeHandler = ( option: SelectOptionTypes, _: ActionMeta<OptionType> ) => {
        if( ! isOptionTypeArray( option )) {
            setSelectedOption( option );

            //call callback, when it exists
            if( onSelectChange ) {
                onSelectChange( option )
            }
        }
    };

    let selectComp = null;

    //make sure redux select state includes this select, otherwise fetch options
    if( typeof selectState[ viewIdentifier ] === 'undefined' || typeof selectState[ viewIdentifier ][ filterName ] === 'undefined') {
        dispatch( fetchInitialSelectOptions( filterName, route, getInitialViewSettings(viewIdentifier) ) )
    } else {

            selectComp = (
                <AsyncSelect
                    viewIdentifier={ viewIdentifier }
                    label={title}
                    language={language}
                    selectState={selectState[ viewIdentifier ][ filterName ]}
                    onSelectChange={selectChangeHandler}
                    route={route}
                    onUserInputChange={ onInputChangeHandler }
                    selectIdentifier={filterName}
                    userViewSettings={selectState[ viewIdentifier ][ filterName ].selectSettings}
                    dense
                />
            );
    }

    const filter = constructDataFilter( filterName, DataFilterTypes.ID );

    const onAddFilterClickHandler = ( activeFilter: DataFilter, isInverted: boolean ) => {
        onAddFilterClick({
            ...activeFilter,
            isInverted: isInverted,
            selectedValue: selectedOption.value,
            displayName: createFilterDisplayTitle(title, selectedOption.label)
        });
    };

    const onInvertedChangeHandler = ( activeFilter: DataFilter, isInverted: boolean ) => {
        setInverted( isInverted );
    };


    return (
        <DataFilterInput
            filter={filter}
            title={title}
            isInvertedActive={inverted}
            onAddFilterClick={onAddFilterClickHandler}
            onInvertedChange={onInvertedChangeHandler}
            noDivider={noDivider}
        >
            { selectComp }
        </DataFilterInput>
    );


}